import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function ReviewIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.60913 10.1218C1.60913 5.42037 5.42041 1.6091 10.1219 1.6091H13.8782C18.5797 1.6091 22.3909 5.42038 22.3909 10.1218V11.5212C22.3909 12.0735 21.9432 12.5212 21.3909 12.5212C20.8386 12.5212 20.3909 12.0735 20.3909 11.5212V10.1218C20.3909 6.52494 17.4751 3.6091 13.8782 3.6091H10.1219C6.52498 3.6091 3.60913 6.52494 3.60913 10.1218V13.8782C3.60913 17.4751 6.52497 20.3909 10.1219 20.3909H11.8125C12.3648 20.3909 12.8125 20.8386 12.8125 21.3909C12.8125 21.9432 12.3648 22.3909 11.8125 22.3909H10.1219C5.4204 22.3909 1.60913 18.5796 1.60913 13.8782V10.1218Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45453 8.36365C6.45453 7.81136 6.90224 7.36365 7.45453 7.36365L16.5454 7.36365C17.0977 7.36365 17.5454 7.81136 17.5454 8.36365C17.5454 8.91593 17.0977 9.36365 16.5454 9.36365L7.45453 9.36365C6.90224 9.36365 6.45453 8.91593 6.45453 8.36365Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45453 12C6.45453 11.4477 6.90224 11 7.45453 11L10.375 11C10.9273 11 11.375 11.4477 11.375 12C11.375 12.5523 10.9273 13 10.375 13H7.45453C6.90224 13 6.45453 12.5523 6.45453 12Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2761 18.7638C17.8494 18.7638 19.1248 17.4884 19.1248 15.9151C19.1248 14.3418 17.8494 13.0664 16.2761 13.0664C14.7028 13.0664 13.4274 14.3418 13.4274 15.9151C13.4274 17.4884 14.7028 18.7638 16.2761 18.7638ZM16.2761 20.7638C18.9539 20.7638 21.1248 18.593 21.1248 15.9151C21.1248 13.2373 18.9539 11.0664 16.2761 11.0664C13.5982 11.0664 11.4274 13.2373 11.4274 15.9151C11.4274 18.593 13.5982 20.7638 16.2761 20.7638Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8014 18.4405C19.192 18.05 19.8251 18.05 20.2157 18.4405L22.3706 20.5955C22.7612 20.986 22.7612 21.6191 22.3706 22.0097C21.9801 22.4002 21.3469 22.4002 20.9564 22.0097L18.8014 19.8547C18.4109 19.4642 18.4109 18.831 18.8014 18.4405Z"
        fill={color}
      />
    </SvgIcon>
  );
}
